WL.registerComponent('rail-system', {
  speed: { type: WL.Type.Float, default: 0.1 },
}, {
  init: function () {
    const children = this.object.children;

    for (let i = 0; i < children.length; i++) {
      const part = children[i];

      switch (part.name) {
        case 'Path':
          this.pathObjects = part.children;
          this.pathObjects.sort((a, b) => { return a.name > b.name ? 1 : a.name == b.name ? 0 : -1 });
          break;
        case 'PracticeTarget':
          this.target = part;
          this.targetMesh = part.getComponent('mesh');
          this.targetMaterial = this.targetMesh.material;
          this.collision = part.getComponent('physx');
          this.counter = part.children.find(part => part.name === 'Counter').getComponent('text');
          console.log(this.counter);
          break;
      }
    }

    this.currentPathObjectIndex = 0;
    this.dir = 1;

    this.lerpTime = 0;
    this.currentPosition = new Float32Array(3);
    this.lastPosition = new Float32Array(3);
    this.fromPosition = new Float32Array(3);
    this.toPosition = new Float32Array(3);
    this.tempVec = new Float32Array(3);

    this.pathObjects[0].getTranslationWorld(this.fromPosition);
    this.pathObjects[1].getTranslationWorld(this.toPosition);
    this.currentPathDistance = glMatrix.vec3.distance(this.fromPosition, this.toPosition);

    this.count = 0;

    this.setEnabled(true);
  },
  setEnabled: function (b, onlyVisible = false) {
    this.targetMesh.active = b;
    this.targetMesh.object.children.forEach(child => {
      child.getComponents()[0].active = b;
    });
    this.isMoving = b;
    if (onlyVisible)
      this.collision.active = false;
    else
      this.collision.active = b;
  },
  onTargetReached: function () {
    this.currentPathObjectIndex += this.dir;

    if (this.currentPathObjectIndex + 1 === this.pathObjects.length || this.currentPathObjectIndex == 0) {
      this.dir *= -1;
    }

    this.lerpTime = 0;

    this.pathObjects[this.currentPathObjectIndex].getTranslationWorld(this.fromPosition);
    this.pathObjects[this.currentPathObjectIndex + this.dir].getTranslationWorld(this.toPosition);
    this.currentPathDistance = glMatrix.vec3.distance(this.fromPosition, this.toPosition);
  },
  setMaterial: function (mat) {
    this.targetMesh.material = mat || this.targetMaterial;
  },
  getPositionDifference: function () {
    glMatrix.vec3.sub(this.tempVec, this.currentPosition, this.lastPosition);
    return this.tempVec;
  },
  update: function (dt) {
    if (this.isMoving) {
      this.lastPosition.set(this.currentPosition);
      this.lerpTime += dt * this.speed / this.currentPathDistance;
      this.lerpTime = Math.min(this.lerpTime, 1);
      glMatrix.vec3.lerp(this.currentPosition, this.fromPosition, this.toPosition, this.lerpTime);
      this.target.setTranslationWorld(this.currentPosition);

      if (this.lerpTime === 1) {
        this.onTargetReached();
      }
    }
  },
  changePath: function () {
    this.pathObjects.forEach(path => {
      path.setTranslationLocal(this.randPos());
    });
    this.pathObjects[0].getTranslationWorld(this.fromPosition);
    this.pathObjects[1].getTranslationWorld(this.toPosition);
  },
  randPos: function () {
    const rand = (min, max) => Math.random() * (max - min) + min;
    const newX = rand(-20, 20);
    const newY = rand(2, 6);
    const newZ = rand(-24, -8);
    return [newX, newY, newZ];
  },
  updateCount: function (increment = true) {
    if (!increment) this.count = -1;
    this.counter.text = `${++this.count}`;
  }
});
